import React, { useState } from "react";
import PropTypes from "prop-types";
import { Avatar } from "@material-ui/core";
import classes from "./nameAvatar.module.css";
import { Col, Container, Row } from "react-bootstrap";
import {
  applyAsCoachIcon,
  helpIcon,
  logoutIcon,
  settingIcon,
} from "../../constant/imagePath";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";

import { getAuth, signOut } from "firebase/auth";
import { useDispatch } from "react-redux";
import { signOutRequest } from "../../store/Actions/authAction";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

export const NameAvatar = ({
  userName,
  backgroundColor,
  textColor,
  isAllowDropDown,
  size,
  customStyle,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  var values = userName !== undefined ? userName.split(" ") : [];
  var fisrtNameAlphabet = values[0] ? values[0].charAt(0) : "";
  var lastNameAlphabet = values[1] ? values[1].charAt(0) : "";
  const [openList, setOpenList] = useState(false);
  const [signoutLoading, setSignoutLoading] = useState(false);

  const HandleSignOut = () => {
    setSignoutLoading(true);
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        dispatch(signOutRequest());
      })
      .catch((error) => {
        toast.error(error.message);
      });
    setSignoutLoading(false);
  };

  return (
    <div className={[classes.mainContainer].join(" ")}>
      <Avatar
        style={{
          backgroundColor: backgroundColor && backgroundColor,
          color: textColor && textColor,
          width: size ? size : "28px",
          height: size ? size : "28px",
          ...Fonts.p4,
          ...customStyle,
        }}
        onClick={() => {
          isAllowDropDown && setOpenList(!openList);
        }}
      >
        {fisrtNameAlphabet.toUpperCase()}
        {lastNameAlphabet.toUpperCase()}
      </Avatar>
      {openList && (
        <Container className={[classes.dropDownContainer].join(" ")}>
          <Row>
            <Col md={12} className={[classes.itemContainer].join(" ")}>
              <img
                src={applyAsCoachIcon}
                alt=""
                className={[classes.icons].join(" ")}
              />
              <span>Apply as Coach</span>
            </Col>
            <Col
              md={12}
              className={[classes.itemContainer].join(" ")}
              onClick={() => history.push("/help")}
            >
              <img
                src={helpIcon}
                alt=""
                className={[classes.icons].join(" ")}
              />
              <span>Help</span>
            </Col>
            <Col
              md={12}
              className={[classes.itemContainer].join(" ")}
              onClick={() => history.push("/student-settings")}
            >
              <img
                src={settingIcon}
                alt=""
                className={[classes.icons].join(" ")}
              />
              <span>Settings</span>
            </Col>
            <Col
              md={12}
              className={[classes.itemContainer].join(" ")}
              onClick={() => {
                signoutLoading == false && HandleSignOut();
              }}
            >
              <img
                src={logoutIcon}
                alt=""
                className={[classes.icons].join(" ")}
              />
              <span>Log out</span>
            </Col>
          </Row>
        </Container>
      )}
    </div>
  );
};

NameAvatar.propTypes = {
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  userName: PropTypes.string.isRequired,
  size: PropTypes.string,
  customStyle: PropTypes.object,
};

NameAvatar.defaultProps = {
  backgroundColor: Colors.neutralShadesOfNero,
  textColor: "#ffffff",
  userName: "Test User",
  size: "28px",
};
